import { formatDateTimeReversed } from "../../../../util/formatsForDate";

export default function RefundsTable({ members, loading }) {
  return (
    <div className="w-full bg-white shadow rounded-lg overflow-hidden" dir="rtl">

      {/* LOADING SKELETON */}
      {loading && (
        <div className="p-6">
          <div className="animate-pulse space-y-3">
            {[1, 2, 3, 4, 5].map((i) => (
              <div key={i} className="h-6 bg-gray-200 rounded"></div>
            ))}
          </div>
        </div>
      )}

      {!loading && (
        <table className="w-full text-right border-collapse">
          <thead className="bg-gray-100 border-b border-gray-300">
            <tr>
              <th className="p-3 border-l border-gray-200">תאריך</th>
              <th className="p-3 border-l border-gray-200">תיאור</th>
              <th className="p-3 border-l border-gray-200">מספר אסמכתא </th>
              <th className="p-3 border-l border-gray-200">מחיר</th>
            </tr>
          </thead>

          <tbody>
            {members?.length === 0 && (
              <tr>
                <td colSpan={6} className="text-center p-4 text-gray-500">
                  אין תוצאות
                </td>
              </tr>
            )}

            {members.map((m) => (
              <tr
                key={m.id}
                className="border-b border-gray-200 hover:bg-gray-50 transition"
              >
                <td className="p-3 border-l border-gray-100">{formatDateTimeReversed(m.createDate || "-")}</td>
                <td className="p-3 border-l border-gray-100">{m.description}</td>
                <td className="p-3 border-l border-gray-100">{m.referenceNumber}</td>
                <td className="p-3 border-l border-gray-100">{m.price}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
